import React from 'react';
import { Controller } from 'react-hook-form';
import FormLabel from './FormLabel';

const FormTextArea = ({ control, name, id, label, maxLength, rules, disabled, height }) => {
  return (
    <div id={id}>
      {label && <FormLabel rules={rules} label={label} id={id} />}
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue=""
        render={({ field, fieldState }) => (
          <div>
            <textarea
              {...field}
              id={id}
              className="form-control"
              style={height ? { height: height } : { height: '100px' }}
              maxLength={maxLength}
              disabled={disabled}
            />
            {fieldState.invalid && <div className="text-danger">{fieldState.error?.message}</div>}
            <p className="text-muted text-right">
              <span id="charCount">
                {field?.value?.length ?? 0}/{maxLength}
              </span>
            </p>
          </div>
        )}
      />
    </div>
  );
};

export default FormTextArea;
